import React, { useContext, useMemo } from 'react';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';

const EditableWageRenderer = (params) => {
  const {
    rowData,
    rowData: { summarized, subRows },
    columnData: { parent = 'wage', wageKey, withPrefix, hideZero = false }
  } = params;
  const { currency } = useContext(ConfigContext);
  const value = useMemo(() => rowData?.[parent]?.[wageKey] ?? 0, [parent, rowData, wageKey]);

  if (subRows || summarized || !rowData?.[parent]?.id) {
    return <></>;
  }

  if (value === 0 && hideZero) {
    return <></>;
  }

  return (
    <>
      {withPrefix && currency}
      {value}
    </>
  );
};

export default EditableWageRenderer;
